import { LINK_PATH } from "../lib/extensionLink.js";

export const paths = {
  login: "/login",
  cancelRecovery: "/wiederherstellung-abbrechen",
  recover: "/wiederherstellung",
  dashboard: "/dashboard",
  vault: "/vault",
  vaultNew: "/vault/new",
  generator: "/generator",
  teams: "/teams",
  invite: "/einladung",
  settings: "/settings",
  admin: "/admin",
  linkExtension: LINK_PATH,
  vaultItem(id: string): string {
    return `/vault/${id}`;
  },
  vaultEdit(id: string): string {
    return `/vault/${id}/edit`;
  },
  team(id: string): string {
    return `/teams/${id}`;
  }
};
